module.exports = __webpack_public_path__ + "static/by-sa-5dc383049332b6645f7c076584e718c7.svg";